/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { InformationComponent } from './information/information.component';
import { HelpComponent } from './help/help.component';
import { ConfirmationDialogData } from './models/confirmation-dialog-data.model';
import { InformationDialogData } from './models/information-dialog-data.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ObjectDialogComponent } from './object-dialog/object-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private defaultConfig = {
    maxWidth: '350px',
    panelClass: 'dialog-rounded-lg',
    width: '100%',
    padding: '20px',
  };

  constructor(private dialog: MatDialog, private snackbar: MatSnackBar) {}

  openSnackbar(message: string, actionText?: string) {
    return this.snackbar.open(message, actionText || 'CERRAR', {
      duration: 3000,
    });
  }

  openSnackbarRed(message: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['red-snackbar', 'my-custom-snackbar'];
    config.duration = 3000;
    this.snackbar.open(message, undefined, config);
  }

  openSnackbarWhite(message: string) {
    this.snackbar.open(message, undefined, {
      duration: 3000,
      panelClass: ['white-snackbar', 'my-custom-snackbar'],
    });
  }

  openConfirmationDialog(data: ConfirmationDialogData) {
    return this.dialog.open(ConfirmationComponent, {
      data,
      ...this.defaultConfig,
    });
  }

  openInformationDialog(data: InformationDialogData) {
    return this.dialog.open(InformationComponent, {
      data,
      ...this.defaultConfig,
    });
  }

  openHelpDialog(type: 'date' | 'info' | 'cvv' = 'cvv') {
    return this.dialog.open(HelpComponent, {
      data: { helpType: type },
      ...this.defaultConfig,
    });
  }

  openJsonDialog(json: any) {
    return this.dialog.open(ObjectDialogComponent, { data: json });
  }
}
